<div class="task-attachments-container">
    <tsl-file-drop
        [inputText]="translate.get('choose a file')" [hintText]="translate.get('Drag and Drop a File or ')"
        *ngIf="!disableAction"
        [disabled]="disableFileUpload()"
        (fileChange)="onFileAdd($event)"
        [multiple]="multiple"
        [accept]="accept"
    ></tsl-file-drop>
    <table class="file-list-item" *ngIf="files?.length > 0">
        <tr>
            <th>Files</th>
            <th *ngIf="!disableAction">Actions</th>
        </tr>
        <tr *ngFor="let file of files">
            <td>
                <span class="file-name-container">
                    <a (click)="downloadFile(file)">
                        {{ file?.fileName ? file.fileName : file.name }}
                    </a>
                </span>
            </td>
            <td *ngIf="!disableAction">
                <span (click)="onFileRemove(file)" class="remove" tsl-button ghost>Remove</span>
            </td>
        </tr>
    </table>
</div>
